import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Download } from "lucide-react";

interface CampaignStatusOption {
  id: number;
  name: string;
}

interface CampaignStatusFiltersProps {
  filters: Record<string, unknown>;
  onFilterChange: (key: string, value: unknown) => void;
  onDownloadCsv: () => void;
  isDownloading: boolean;
  campaignStatuses: CampaignStatusOption[];
}

const CampaignStatusFilters: React.FC<CampaignStatusFiltersProps> = ({
  filters,
  onFilterChange,
  onDownloadCsv,
  isDownloading,
  campaignStatuses,
}) => {
  return (
    <div className="mb-4 space-y-4">
      <div className="flex gap-4 items-end">
        <div className="flex-[4]">
          <Label htmlFor="intacctId">Company Identifier</Label>
          <Input
            id="intacctId"
            onChange={(e) => onFilterChange("companyName", e.target.value)}
            placeholder="Search by Intacct ID"
            type="text"
            value={(filters.companyName as string) || ""}
          />
        </div>

        <div className="flex-1">
          <Label htmlFor="campaignStatus">Campaign Status</Label>
          <Select
            onValueChange={(value) => {
              onFilterChange(
                "campaignStatusId",
                value === "all" ? undefined : parseInt(value, 10),
              );
            }}
            value={
              filters.campaignStatusId
                ? String(filters.campaignStatusId)
                : "all"
            }
          >
            <SelectTrigger id="campaignStatus">
              <SelectValue placeholder="All Statuses" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Statuses</SelectItem>
              {campaignStatuses.map((status) => (
                <SelectItem key={status.id} value={String(status.id)}>
                  {status.name.charAt(0).toUpperCase() +
                    status.name.slice(1).toLowerCase()}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button
          className="flex items-center gap-2"
          disabled={isDownloading}
          onClick={onDownloadCsv}
        >
          <Download className="h-4 w-4" />
          {isDownloading ? "Downloading..." : "Export CSV"}
        </Button>
      </div>
    </div>
  );
};

export default CampaignStatusFilters;
